import styled from 'styled-components';

const DEFAULT_SIZE = 50;

export const CircularProgressRotator = styled.div<ICircularProgressRotator>`
    width: ${props => props.size || DEFAULT_SIZE }px;
    height: ${props => props.size || DEFAULT_SIZE }px;
    stroke: ${props => props.color || 'inherit'};
    animation: rotateCircularProgress 1.4s linear infinite;
    
    svg {
        circle {
            animation: animateCircularDash 1.4s ease-in-out infinite;
            stroke-dasharray: 5.000em, 12.500em;
            stroke-dashoffset: 0;
        }
    }
    
    @keyframes rotateCircularProgress {
        100% {
            transform: rotate(360deg);
        }
    }
    
    @keyframes animateCircularDash {
        0% {
            stroke-dasharray: 0.063em, 12.500em;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 6.250em, 12.500em;
            stroke-dashoffset: -0.938em;
        }
        100% {
            stroke-dasharray: 6.250em, 12.500em;
            stroke-dashoffset: -7.500em;
        }
    }
`;

CircularProgressRotator.displayName = 'CircularProgressRotator';

interface ICircularProgressRotator {
    readonly size?: number;
    readonly color?: string;
}

export const CircularProgressContainer = styled.div``;

CircularProgressContainer.displayName = 'CircularProgressContainer';
